import React, { useRef, useState } from 'react';
import { useOutsideAlerter } from 'Services/helpers';
import CssHelper from 'Services/Utils/Css/CssHelper';
import styles from './BaseField.module.sass';

const BaseField = ({
    children,
    iconBefore, iconAfter,
    hasValue, size,

    ...props
}: Props) => {
    const [state, setState] = useState({
        isFocused: false
    });

    const wrapperRef = useRef(null);
    useOutsideAlerter(() => {
        handleFocus(false)();
    }, [wrapperRef], state.isFocused);

    const cssClass = CssHelper.createCssClass(`
        ${styles['basefield']}
        ${styles['basefield__state--'+(
            state.isFocused
            ? 'focused'
            : hasValue
            ? 'active'
            : 'inactive'
            )]}
        ${styles['basefield__size--'+(size||'large')]}
    `);

    const handleFocus = (value: boolean) => () => {
        setState((state) => ({
            ...state,
            isFocused: value
        }));

        props?.onFocus(value);
        // @ts-ignore
        props?.onClick();
    }

    return <div
        ref={wrapperRef}
        className={cssClass}
        onClick={handleFocus(true)}
    >
        { iconBefore }
        { children }
        { iconAfter }
    </div>
}

interface Props {
    iconBefore?: any
    iconAfter?: any

    hasValue?: boolean
    size?: 'small' | 'medium' | 'large'

    onFocus: any

    className?: any
    children: any
}

export default BaseField;